import { sqliteTable, text, integer, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// payroll_entries — การจ่ายเงินเดือน (Payroll Entry)
// ============================================================================
export const payrollEntries = sqliteTable("hr_payroll_entries", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  payrollNo: text("payroll_no").notNull(),
  payrollMonth: text("payroll_month").notNull(), // YYYY-MM
  status: text("status").notNull().default("draft"), // draft, submitted, paid, cancelled
  totalEmployees: integer("total_employees").notNull().default(0),
  totalEarnings: real("total_earnings").notNull().default(0),
  totalDeductions: real("total_deductions").notNull().default(0),
  totalNetPay: real("total_net_pay").notNull().default(0),
  paymentDate: text("payment_date"),
  paymentMethod: text("payment_method"), // bank_transfer, cash, cheque
  // Audit columns
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  pe_company_month_idx: index("pe_company_month_idx").on(table.companyId, table.payrollMonth),
  pe_status_idx: index("pe_status_idx").on(table.companyId, table.status),
}));

// Type exports
export type PayrollEntry = typeof payrollEntries.$inferSelect;
export type NewPayrollEntry = typeof payrollEntries.$inferInsert;
